import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logo } from './Logo';
import { MdClose } from 'react-icons/md';
import { Menu } from 'react-feather';
import { Button } from 'components/Elements';
import { useAuth } from 'lib/auth';
import { UserNavigation } from './UserNavigation';
import { Sun, Moon } from 'react-feather'; // Import icons for the toggle

const LinkItems = [
  {
    title: 'Home',
    link: '/',
  },
  {
    title: 'About Us',
    link: '/about-us',
  },
  {
    title: 'Construction',
    link: '/construction',
  },
  {
    title: 'Designs',
    link: '/designs',
  },
  {
    title: 'Contact Us',
    link: '/contact-us',
  },
];

const LinkItem = ({ title, link }) => {
  return (
    <Link
      to={link}
      className="my-1 text-md text-gray-700 font-medium hover:text-indigo-500 md:mx-4 md:my-0"
    >
      {title}
    </Link>
  );
};

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check local storage for theme preference
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });

  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Set the theme in local storage
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    document.body.classList.toggle('dark', isDarkMode);
  }, [isDarkMode]);

  return (
    <nav className={`bg-white px-3 md:px-48 py-3 md:py-5 transition-colors duration-300`}>
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex justify-between space-x-32 items-center">
          <div>
            <Logo />
          </div>
          <div>
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="block text-gray-800 hover:text-gray-700 focus:text-gray-700 focus:outline-none md:hidden"
            >
              {isOpen ? (
                <MdClose className="h-6 w-6 fill-current" />
              ) : (
                <Menu className="h-6 w-6 fill-current" />
              )}
            </button>
          </div>
        </div>

        <div className={`md:flex items-center ${isOpen ? '' : 'hidden'}`}>
          <div className="flex flex-col items-center md:space-x-4 md:flex-row md:mx-6">
            {LinkItems.map((item, index) => (
              <LinkItem key={index} title={item.title} link={item.link} />
            ))}
            {user ? (
              <UserNavigation />
            ) : (
              <div className="flex flex-col items-center md:space-x-10 md:flex-row md:mx-6">
                <button
                  onClick={() => navigate('/auth/login')}
                  variant="secondary"
                  className="whitespace-nowrap uppercase bg-[#142852] p-2 text-white px-4 transition-all duration-300 ease-in-out hover:bg-gradient-to-r hover:from-[#1e3c72] hover:to-[#2a69d0] hover:text-white shadow-lg transform hover:scale-105"
                >
                  GO TO ACCOUNT
                </button>
              </div>
            )}
            {/* Dark Mode Toggle */}
            {/* <button
              onClick={() => setIsDarkMode((prev) => !prev)}
              className="text-gray-800 dark:text-white"
            >
              {isDarkMode ? <Sun className="h-6 w-6" /> : <Moon className="h-6 w-6" />}
            </button> */}
          </div>
        </div>
      </div>
    </nav>
  );
};
